<template>
  <v-img
    id="static - image"
    class="static-image"
    :src="$ebsn.meta(config, 'categoryblocktype_StaticImage.IMAGE.location')"
  />
</template>
<script>
export default {
  name: "StaticImage",
  props: {
    config: { type: Object, required: true }
  }
};
</script>
